export const defaultOptimizelyFlags = {
  test_1: {
    enabled: false
  },
  test_2: {
    enabled: false
  }
} as const;
